import React from "react";
import { motion } from "framer-motion";
import { Ghost } from "lucide-react";
import { siteConfig } from '../constant/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

const NotFound = () => {
    const { t } = useLanguage();

    return (
        <div
            className="flex flex-col items-center justify-center h-screen text-white"
            style={{ backgroundColor: siteConfig.brandColors.primary }}
        >
            <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <Ghost className="w-24 h-24 text-white animate-bounce" />
            </motion.div>
            <motion.h1
                className="text-5xl font-bold mt-6"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.8 }}
            >
                404
            </motion.h1>
            <motion.p
                className="text-lg mt-2"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 0.8 }}
            >
                {t('notFound.message')}
            </motion.p>
            <motion.a
                href={siteConfig.paymentSucceededPageRedirectLink}
                className="mt-6 px-6 py-3 bg-white font-semibold rounded-full shadow-lg hover:bg-gray-200 transition"
                style={{ color: siteConfig.brandColors.primary }}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1.5, duration: 0.5 }}
            >
                {t('common.goHome')}
            </motion.a>
        </div>
    );
};

export default NotFound;
